<app-app-nav></app-app-nav>
<!-- END header -->
<main id="mainContent" tabindex="-1">
  <!-- whatsapp floating button -->
  <app-whatsapp></app-whatsapp>
  <!-- END whatsapp floating button -->

  <section class="news-page py-5">
    <div class="container-fluid news-inner">

      <!-- Page title -->
      <div class="news-head d-flex justify-content-between align-items-center flex-wrap">
        <div class="news-head-title d-flex align-items-center animate__animated animate__fadeInUp wow">
          <span class="news-head-accent"></span>
          <h1 class="heading-font fw-bold mb-0">دراسات و بحوث</h1>
        </div>
      </div>

      <!-- Research list -->
      <section class="mt-2">
        <!-- Filter bar: keyword search -->
        <div class="news-filter-bar d-flex flex-wrap align-items-center gap-2 mb-4">
          <div class="news-filter-search position-relative flex-grow-1">
            <i class="icon-search news-filter-search-icon"></i>
            <input type="text" class="form-control" [(ngModel)]="keyword" (ngModelChange)="applyKeyword()"
              placeholder="ابحث في الأبحاث بكلمة..." aria-label="ابحث في الأبحاث">
          </div>
          <button type="button" class="btn btn-outline-secondary news-filter-clear"
            *ngIf="keyword" (click)="clearFilters()">
            مسح الفلتر
          </button>
        </div>

        <!-- No results -->
        <div class="text-center py-5 text-secondary" *ngIf="researchList && researchList.length === 0">
          لا توجد أبحاث مطابقة لبحثك.
        </div>

        <div class="latest-list">
          <a class="latest-card animate__animated animate__fadeIn wow" *ngFor="let item of researchList"
            (click)="Details(item)" role="button" tabindex="0" (keydown.enter)="Details(item)" (keydown.space)="Details(item)">
            <div class="latest-media overflow-hidden">
              <img class="latest-img" src="{{item.IMG_PATH}}" [alt]="item.TITLE" alt="">
            </div>
            <div class="latest-body">
              <h3 class="latest-title heading-font">{{item.TITLE}}</h3>
              <p class="latest-brief" *ngIf="item.DETAILS">{{item.DETAILS}}</p>
              <div class="research-card-actions">
                <span class="news-card-more">اقرأ المزيد <i class="icon-arrow-sm"></i></span>
                <a *ngIf="item.LINK" [href]="item.LINK" target="_blank" rel="noopener noreferrer"
                  class="research-link-btn" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
                  <svg class="research-link-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                  </svg>
                  الاطلاع على البحث
                </a>
              </div>
            </div>
          </a>
        </div>
      </section>

    </div>
  </section>
</main>
